import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import baseConfig from "./SearchConfig";

const connector = new AppSearchAPIConnector({
  searchKey: "search-2f7pnod8kxxe8vo7733wk7su",
  engineName: "frt",
  endpointBase: "https://frtv2.ent.ca-central-1.aws.elastic-cloud.com",
});

function removeValidDate(state) {
  if ("filters" in state) {
    state.filters = state.filters.filter((x) => x.field !== "valid_date");
  }
  return state;
}

const config = {
  ...baseConfig,
  apiConnector: connector,
  onSearch: (state, queryConfig, next) => {
    const updatedState = removeValidDate(state);
    return next(updatedState, queryConfig);
  },
};

export default config;
